// frontend/src/lib/firebaseFirestore.ts
import { Firestore } from 'firebase/firestore';
import { initializeFirebaseCore } from './firebase/firebase';

// Create a promise that resolves to the Firestore service instance
// Handle server-side contexts gracefully
let firestorePromise: Promise<Firestore | null>;

if (typeof window === 'undefined') {
    // We're on the server-side
    console.log(
        '[firebaseFirestore] Detected server-side context. Returning a dummy Firestore promise.'
    );
    // Return a promise that resolves to null, which is safer for SSR
    firestorePromise = Promise.resolve(null);
} else {
    // We're on the client-side
    firestorePromise = initializeFirebaseCore()
        .then((services) => {
            if (!services.db) {
                console.warn(
                    '[firebaseFirestore] Firestore service is not available from initializeFirebaseCore (client).'
                );
                // Return null instead of throwing, to avoid breaking consuming components
                return null;
            }
            console.log(
                '[firebaseFirestore] Firestore service obtained from initializeFirebaseCore (client).'
            );
            return services.db;
        })
        .catch((error) => {
            console.error(
                '[firebaseFirestore] Error obtaining Firestore service from initializeFirebaseCore (client):',
                error
            );
            // Return null instead of re-throwing, to avoid breaking consuming components
            return null;
        });
}

export { firestorePromise as firestore };

// Also export a helper function that components can use for reactive checking
export function isFirestoreAvailable(): boolean {
    return typeof window !== 'undefined';
}
